<template>
  <div class="newimgs">
    <img style="height: 140vh; width: 100vw" :src="addressphoto" alt />
  </div>
</template>

<script>
export default {
  props: {
    addressphoto: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped>
.newimgs {
  width: 100vw;
  height: 140vh;
  box-sizing: border-box;
}
.newimgs img {
  width: 100vw;
  height: 140vh;
}
</style>
